import css from "standard/css";

const style = css`
  .profile__form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: var(--spacing_inset-sm);
  }

  .profile__save {
    align-items: center;
    background-color: #3481b2;
    border: none;
    border-bottom: 2px solid #5c9ac1;
    border-radius: var(--border-radius-sm);
    box-shadow: 0 10px 0 #2a668c;
    text-shadow: 0 2px 0 rgba(0, 0, 0, 0.2);
    color: var(--color-pure-white);
    cursor: pointer;
    display: flex;
    font-family: var(--font-family-highlight);
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-bold);
    padding: var(--spacing_inset-nano) var(--spacing_inset-xs);
    justify-content: center;
    width: 150px;
  }
`;

export default style;
